import React from "react";
import funnel from "../../styles/Funnel.module.css";
import Box from "@mui/material/Box";
import { alpha, styled } from "@mui/material/styles";
import { NumericFormat } from "react-number-format";
import InputAdornment from "@mui/material/InputAdornment";
import FormControl from "@mui/material/FormControl";
import TextField from "@mui/material/TextField";

let CssTextField = styled(TextField)({
  "& .MuiOutlinedInput-root": {
    "&:hover fieldset": {
      borderColor: "var(--primary-color)",
    },
    "&.Mui-focused fieldset": {
      borderColor: "var(--primary-color)",
    },
  },
});

function Mortgage({ formData, setFormData, errorm, setErrorm }) {
  let error;
  let helperText;
  if (errorm == true) {
    error = "error";
    helperText = "Mortgage value cannot be empty!";
  } else {
    error = "";
    helperText = "";
  }

  const handleChange = (event) => {
    setFormData({
      ...formData,
      price_mortgage: event.target.value,
    });
    setErrorm(false);
  };

  return (
    <Box sx={{ display: "flex", justifyContent: "center" }}>
      <div className={funnel.boxQn}>
        <h2 className={funnel.h2Text}>How much mortgage can you get?</h2>
        <FormControl fullWidth>
          <NumericFormat
            error={error}
            helperText={helperText}
            value={formData.price_mortgage}
            name="price_mortgage"
            placeholder="example: 10000"
            onChange={handleChange}
            id="outlined-adornment-amount"
            thousandSeparator=","
            customInput={CssTextField}
            InputProps={{
              startAdornment: (
                <InputAdornment position="start">$</InputAdornment>
              ),
            }}
          />
        </FormControl>
      </div>
    </Box>
  );
}

export default Mortgage;
